import React from "react";
import CarouselBanner from "../components/CarouselBanner";
import ProgramUi from "../components/Events";
import KeyFiguresUi from "../components/Keyfigure";
import AdministrativeLayout from "../components/AdministrativeLayout";
import OfficerCardLayout from "../components/OfficerCardLayout";
import VillageLayout from "../components/VillageLayout";
import QuickLinksSection from "../components/QuickLinks";
import FullLayout from "../components/PhotoGallery";
import VillageIllustration from "../components/VillageIllustration";
import LogoCard from "../components/LogoCard";

export default function Home() {
  return (
    <div style={{ background: '#fff' }}>
      <CarouselBanner />

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <ProgramUi className="section-padding" />
        <KeyFiguresUi className="section-padding" />
      </div>

      <div className="full-width-bg" style={{ background: 'linear-gradient(180deg, #FFFFFF 45.48%, #EDF7E6 109.58%)' }}>
        <AdministrativeLayout className="section-padding" />
        <LogoCard className="section-padding" />
      </div>

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <OfficerCardLayout className="section-padding" />
      </div>

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <VillageIllustration />
      </div>

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <VillageLayout className="section-padding" />
      </div>

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <QuickLinksSection className="section-padding" />
      </div>

      <div className="full-width-bg" style={{ background: '#fff' }}>
        <FullLayout className="section-padding" />
      </div>
    </div>
  );
}
